import React, { useCallback, useState, useMemo } from 'react';
import InputAdornment from '@material-ui/core/InputAdornment';
import IconButton from '@material-ui/core/IconButton';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';

import StyledTextField from 'components/StyledTextField/StyledTextField';
import { translate } from 'services/i18nService';


const PasswordInputField = (props) => {
  const [showPassword, setShowPassword] = useState(false);

  const handleClick = useCallback(() => {
    setShowPassword(!showPassword);
  }, [showPassword]);

  const iconElement = useMemo(() => {
    if (showPassword) {
      return <VisibilityOff />;
    }

    return <Visibility />;
  }, [showPassword]);

  return (
    <StyledTextField
      {...props}
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            <IconButton
              aria-label="Toggle password visibility"
              size="small"
              title={translate('strings.show.password')}
              onClick={handleClick}
            >
              {iconElement}
            </IconButton>
          </InputAdornment>
        ),
      }}
      type={showPassword ? 'text' : 'password'}
    />
  );
};

export default PasswordInputField;
